if (!customElements.get('anso-product-description')) {
  customElements.define('anso-product-description', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      const labels = new Map([
        ['OPIS', 'OPIS'],
        ['SKŁADNIKI', 'SKŁADNIKI'],
        ['SKLADNIKI', 'SKŁADNIKI'],
        ['JAK UŻYWAĆ', 'JAK UŻYWAĆ'],
        ['JAK UZYWAC', 'JAK UŻYWAĆ'],
      ]);
      const normalize = (text) => text.trim().replace(/\s+/g, ' ').replace(/:$/, '').toLocaleUpperCase('pl');
      const headings = [...this.querySelectorAll('h1, h2, h3, h4, h5, h6, p')]
        .filter((node) => labels.has(normalize(node.textContent)));
      if (!headings.length) return;
      const fragment = document.createDocumentFragment();
      const intro = document.createRange();
      intro.selectNodeContents(this);
      intro.setEndBefore(headings[0]);
      fragment.append(intro.cloneContents());
      headings.forEach((heading, index) => {
        const details = document.createElement('details');
        details.className = 'anso-product-description__section';
        const summary = document.createElement('summary');
        summary.textContent = labels.get(normalize(heading.textContent));
        const content = document.createElement('div');
        content.className = 'anso-product-description__content';
        const range = document.createRange();
        range.selectNodeContents(this);
        range.setStartAfter(heading);
        if (headings[index + 1]) range.setEndBefore(headings[index + 1]);
        content.append(range.cloneContents());
        details.append(summary, content);
        fragment.append(details);
      });
      this.replaceChildren(fragment);
      this.dataset.enhanced = 'true';
    }
  });
}
